/* eslint-disable */
import Ace from 'ace-builds';

Ace.config.setModuleUrl(
  'ace/mode/html',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/mode-html.js')
);
Ace.config.setModuleUrl(
  'ace/mode/html_worker',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/worker-html.js')
);

// Chrome theme
Ace.config.setModuleUrl(
  'ace/theme/chrome',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/theme-chrome.js')
);

// Search box extension (Ctrl+F / Cmd+F)
Ace.config.setModuleUrl(
  'ace/ext/searchbox',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/ext-searchbox.js')
);

export default Ace;
